<div>

    <div class="buttons">
        <button matButton="filled" class="actionbutton" (click)="createUser()">
            <mat-icon>add</mat-icon>
            Neuer Benutzer
        </button>
    </div>

    <table [dataSource]="userList"
           mat-table
           class="user-table">

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr style="cursor: pointer" mat-row *matRowDef="let user; columns: columnsToDisplay"
            (click)="openUser(user)"></tr>

        <ng-container matColumnDef="username">
            <th mat-header-cell *matHeaderCellDef>Benutzername</th>
            <td mat-cell *matCellDef="let user;">{{user.username}}</td>
        </ng-container>

        <ng-container matColumnDef="enabled">
            <th mat-header-cell *matHeaderCellDef>Aktiviert</th>
            <td mat-cell *matCellDef="let user;">{{user.enabled ? "Ja" : "Nein"}}</td>
        </ng-container>

        <ng-container matColumnDef="allowRead">
            <th mat-header-cell *matHeaderCellDef>Leserechte</th>
            <td mat-cell *matCellDef="let user;">{{user.allowRead ? "Ja" : "Nein"}}</td>
        </ng-container>

        <ng-container matColumnDef="allowWrite">
            <th mat-header-cell *matHeaderCellDef>Schreibrechte</th>
            <td mat-cell *matCellDef="let user;">{{user.allowWrite ? "Ja" : "Nein"}}</td>
        </ng-container>

    </table>
</div>
